module.exports = __webpack_public_path__ + "static/media/iv-ambientworks.574228c.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ambient-works/iv-ambientworks.mp3
// module id = Rg7M
// module chunks = 0